import { ca } from '@cian/analytics';

export function trackCianMortgageLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'click_sopr',
    label: 'bank_mortgage_send_app',
    page: {
      extra: {
        is_bank_mortgage: true,
        source: 'DifferentPrices',
      },
    },
  });
}
